export const userFieldLabels = {
  title: {
    id: 'Patient.MyAccount.Title',
    defaultMessage: '** Title',
  },
  name: {
    id: 'Patient.MyAccount.Name',
    defaultMessage: '** Name',
  },
  gender: {
    id: 'Patient.MyAccount.Gender',
    defaultMessage: '** Gender',
  },
  dateOfBirth: {
    id: 'Patient.MyAccount.DateOfBirth',
    defaultMessage: '** Date Of Birth',
  },
  email: {
    id: 'Patient.MyAccount.EmailAddress',
    defaultMessage: '** Email address',
  },
  phoneNumber: {
    id: 'Patient.MyAccount.MobilePhone',
    defaultMessage: '** Mobile phone',
  },
  policyId: {
    id: 'Patient.MyAccount.UserID',
    defaultMessage: '** User ID',
  },
  address: {
    id: 'Patient.MyAccount.Address',
    defaultMessage: '** Address',
  },
  description: {
    id: 'Patient.MyAccount.Profile',
    defaultMessage: '** Profile',
  },
};
